// extracted by mini-css-extract-plugin
export default {"flex-row":"styles_flex-row__fc4De"};